var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightInactive = function SvgRightInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC9D4",
    fillRule: "evenodd",
    d: "M10.244 7.256a.833.833 0 1 1 1.179-1.179l3.333 3.334a.833.833 0 0 1 0 1.178l-3.333 3.334a.833.833 0 0 1-1.179-1.179l1.91-1.91h-6.32a.833.833 0 0 1 0-1.667h6.32l-1.91-1.911Z",
    clipRule: "evenodd"
  })));
};
export default SvgRightInactive;